import Link from 'next/link'
import MarketplaceHeroPanel, { HERO_PRIMARY_BUTTON, HERO_SECONDARY_BUTTON } from './MarketplaceHeroPanel'

export default function CatalogHero() {
  return (
    <MarketplaceHeroPanel>
      <div className="pb-14 pt-12 sm:py-16 lg:py-20">
        <div>
          <h1 className="text-[52px] font-medium leading-[56px] tracking-[-2px] text-primary-green-85 sm:text-[64px] sm:leading-[68px] sm:tracking-[-2.5px] lg:text-[80px] lg:leading-[84px] lg:tracking-[-3px]">
            Marketplace
          </h1>
          <p className="mt-4 max-w-xl text-[17px] leading-relaxed text-white/80 sm:text-lg">
            Microsoft 365, Office 365, Dynamics 365, Google Workspace, and security licenses, with GCC and GCC High for
            defense contractors and teams handling CUI.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center">
            <a href="#browse" className={HERO_PRIMARY_BUTTON}>
              Browse licenses
            </a>
            <Link href="/marketplace/microsoft/licensing-guide" className={HERO_SECONDARY_BUTTON}>
              How licensing works
            </Link>
          </div>
        </div>
      </div>
    </MarketplaceHeroPanel>
  )
}
